function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "music-solid_1_",
  "data-name": "music-solid (1)",
  d: "M15.972,11.472A2.775,2.775,0,0,1,13,13.972,2.774,2.774,0,0,1,10.028,11.5,2.754,2.754,0,0,1,13,9.028a3.509,3.509,0,0,1,1,.153V4.628L6,7v6.5A2.812,2.812,0,0,1,2.972,16,2.739,2.739,0,0,1,0,13.5a2.754,2.754,0,0,1,2.972-2.472,3.505,3.505,0,0,1,1,.153V3.953A1.064,1.064,0,0,1,4.672,3L14.644.047A1.909,1.909,0,0,1,15,0a1,1,0,0,1,1,1Z",
  fill: "#333"
});

function SvgMusicSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicSolid);
export default __webpack_public_path__ + "static/media/music-solid.6f73ea9d.svg";
export { ForwardRef as ReactComponent };